<template>
    <div class="flex-grow-0 flex flex-col">
        <div class="mb-8 md:mb-11">
            <div
                class="text-green flex flex-row items-center gap-4 mb-2"
                v-if="item.Availability > 0"
            >
                <div class="rounded-full bg-green w-3 h-3"></div>
                {{ availOrLeadText() }}
            </div>
            <div
                class="text-yellow flex flex-row items-center gap-4 mb-2"
                v-else-if="item.LeadTime > 0"
            >
                <div class="rounded-full bg-yellow w-3 h-3"></div>
                {{ availOrLeadText() }}
            </div>
            <div class="text-red flex flex-row items-center gap-4 mb-2" v-else>
                <div class="rounded-full bg-red w-3 h-3"></div>
                To be confirmed
            </div>

            <div class="ml-7 mb-6 text-f7">
                Will be confirmed on the final order confirmation.
            </div>

            <div class="ml-7 mb-4">
                Do you have questions about shipping?
                <a
                    href="/purchase-and-delivery-conditions"
                    class="underline"
                    target="_blank"
                    >Click here</a
                >
            </div>
        </div>

        <div
            class="flex-grow-0 border border-grey-200 py-5 px-5 flex flex-row gap-8 justify-center mb-8 md:mb-11 rounded-m"
        >
            <button
                @click.stop="addToOfferList()"
                class="flex flex-row items-center gap-4"
            >
                <div class="btn-list-cb"></div>
                <span class="hidden sm:inline">OFFER</span>
            </button>

            <button
                @click.stop="addToWatchlist()"
                class="flex flex-row items-center gap-4"
            >
                <div class="btn-pin-cb"></div>
                <span class="hidden sm:inline">ADD TO WATCHLIST</span>
            </button>
            <button
                @click.stop="addToCompare()"
                class="flex flex-row items-center gap-4"
            >
                <div class="btn-compare-cb"></div>
                <span class="hidden sm:inline">COMPARE</span>
            </button>
        </div>
        <div class="flex flex-row items-center gap-4">
            <button
                class="w-8 h-8 bg-grey-50 hover:bg-grey-10 rounded-s font-bold text-f6"
                @click="quantity > 1 ? quantity-- : null"
            >
                -
            </button>
            <input
                type="number"
                v-model="quantity"
                class="w-12 text-center border-none text-f6 font-bold quantity-input"
                min="1"
            />
            <button
                class="w-8 h-8 bg-grey-50 hover:bg-grey-100 rounded-s font-bold text-f6"
                @click="quantity++"
            >
                +
            </button>
            <button
                class="px-4 py-2 bg-primary hover:bg-primary-light text-white rounded-s flex flex-row items-center gap-4 flex-grow text-center justify-center"
                @click.stop="addToCart(item.ItemCode, quantity)"
            >
                <span class="font-bold">Add to cart</span>
                <i class="fas fa-shopping-cart"></i>
            </button>
        </div>
    </div>
</template>

<script>
import { BASEURL } from "@libTs/cms.globals";

export default {
    inject: [
        "cartSvc",
        "productsSvc",
        "watchlistSvc",
        "overlaysSvc",
        "itemSvc",
        "compareSvc",
        "offerSvc",
    ],
    props: {
        item: {
            type: Object,
            required: true,
        },
        image: {
            type: String,
            required: false,
            default: null,
        },
    },
    data() {
        return {
            quantity: 1,
            isLoggedIn: this.cartSvc.isUserLoggedIn(),
            baseUrl: BASEURL,
        };
    },
    methods: {
        addToCart(artnr, qty) {
            if (this.isLoggedIn) {
                this.cartSvc.addItemToCart(
                    {
                        ItemCode: this.item.ItemCode,
                        ItemName: this.item.ItemName,
                        Preis: this.item.Preis,
                        SpecialPrice: this.item.Preis,
                        ImageURL: this.image ?? "",
                    },
                    qty,
                );
            } else {
                this.overlaysSvc.showOverlay("loginForm");
            }
        },
        addToWatchlist() {
            if (this.isLoggedIn) {
                this.watchlistSvc.add({
                    ItemCode: this.item.ItemCode,
                    ItemName: this.item.ItemName,
                    ImageURL: this.image ?? "",
                });
            } else {
                this.overlaysSvc.showOverlay("loginForm");
            }
        },
        addToOfferList() {
            if (this.isLoggedIn) {
                this.offerSvc.add({
                    ItemCode: this.item.ItemCode,
                    ItemName: this.item.ItemName,
                    ImageURL: this.image ?? "",
                    Quantity: 1,
                    Preis: this.item.Preis,
                });
            } else {
                this.overlaysSvc.showOverlay("loginForm");
            }
        },
        addToCompare() {
            if (this.isLoggedIn) {
                this.compareSvc.add({
                    ItemCode: this.item.ItemCode,
                    ItemName: this.item.ItemName,
                    ImageURL: this.image ?? "",
                    Group: this.item.ItmsGrpNam ?? "",
                });
            } else {
                this.overlaysSvc.showOverlay("loginForm");
            }
        },
        availOrLeadText() {
            return this.itemSvc.availOrLeadText(
                this.item.Availability,
                this.item.LeadTime,
            );
        },
    },
};
</script>

<style scoped></style>
